import React from "react";
import css from "../../css/find-agent/jumbotron.module.css";
import SearchForm from "./SearchForm";
import PropTypes from "prop-types";

const Jumbotron = (props) => {
    const { city } = props;

    return (
        <div className={css.jumbotron}>
            <div className={css.wrapper}>
                <h1>
                    Browse thousands
                    <br /> of agents to find one.
                </h1>
                <SearchForm city={city} />
            </div>
        </div>
    );
};

Jumbotron.propTypes = {
    city: PropTypes.object,
};

export default Jumbotron;
